import { IS_DEV_ENV } from "constants/app.constants";
import { EntityType } from "constants/entities.enum";
import { createEntityState } from "entities/charts/factory";
import { createMergeWithDefaults } from "entities/utils";
import { EvaChartFeatures } from "types";

import {
  DEFAULT_HIGHLIGHTED_LINE_OPACITY_FEATURE_ENTITY,
  DEFAULT_HIGHLIGHTED_LINE_SIZE_FEATURE_ENTITY,
  DEFAULT_LINE_OPACITY_FEATURE_ENTITY,
  DEFAULT_LINE_SIZE_FEATURE_ENTITY,
  DEFAULT_POINT_OPACITY_FEATURE_ENTITY,
  DEFAULT_POINT_SIZE_FEATURE_ENTITY
} from "./feature";

const TOTAL_RATE_DATE_MIDSTREAM_FEATURES: Partial<EvaChartFeatures> = {
  screenshot: createEntityState(EntityType.ScreenshotFeature, {
    show: true,
    enabled: true
  }),
  fullScreen: createEntityState(EntityType.ChartsFeature, {
    show: true,
    enabled: true
  }),
  datatable: createEntityState(EntityType.ChartDataTableFeature, {
    show: true,
    enabled: true
  }),
  spaghetti: createEntityState(EntityType.ChartsFeature, { show: true, enabled: false }),
  debug: createEntityState(EntityType.ChartsFeature, {
    show: IS_DEV_ENV,
    enabled: IS_DEV_ENV
  }),
  cutoff: createEntityState(EntityType.CutOffChartFeature, {
    show: true,
    enabled: true
  }),
  shutInMonths: createEntityState(EntityType.ShutInMonthsChartFeature, {
    show: true,
    enabled: true
  }),
  movingAverageDays: createEntityState(EntityType.MovingAverageDaysChartFeature, {
    show: true,
    enabled: true
  }),
  survivorBias: createEntityState(EntityType.ChartsFeature, {
    show: true,
    enabled: true,
    active: true
  }),
  // Shown for a consistent menu; nothing is padded into this chart, so it cannot act.
  survivorBiasAsForecast: createEntityState(EntityType.ChartsFeature, {
    show: true,
    enabled: false
  }),
  useWeightedRatioAverage: createEntityState(EntityType.ChartsFeature, {
    show: true,
    enabled: true,
    active: true
  }),
  lockUnits: createEntityState(EntityType.ChartsFeature, {
    show: true,
    enabled: true
  }),
  lasso: createEntityState(EntityType.LassoFeature, {
    show: true,
    enabled: false
  }),
  p10: createEntityState(EntityType.P10Feature, {
    show: true,
    enabled: false
  }),
  p50: createEntityState(EntityType.P50Feature, {
    show: true,
    enabled: false
  }),
  p90: createEntityState(EntityType.P90Feature, {
    show: true,
    enabled: false
  }),
  average: createEntityState(EntityType.AverageFeature, {
    show: true,
    enabled: false
  }),
  chartFocus: createEntityState(EntityType.ChartFocusMidStreamFeature, {
    show: true,
    enabled: true
  }),
  legend: createEntityState(EntityType.ChartsFeature, {
    show: true,
    enabled: true
  }),
  logAxis: createEntityState(EntityType.LogAxisFeature, {
    properties: {
      x: { active: false },
      y: { active: false }
    }
  }),
  lineSize: {
    ...DEFAULT_LINE_SIZE_FEATURE_ENTITY,
    show: false,
    enabled: false
  },
  lineOpacity: {
    ...DEFAULT_LINE_OPACITY_FEATURE_ENTITY,
    show: false,
    enabled: false
  },
  highlightedLineSize: {
    ...DEFAULT_HIGHLIGHTED_LINE_SIZE_FEATURE_ENTITY,
    show: false,
    enabled: false
  },
  highlightedLineOpacity: {
    ...DEFAULT_HIGHLIGHTED_LINE_OPACITY_FEATURE_ENTITY,
    show: false,
    enabled: false
  },
  pointSize: {
    ...DEFAULT_POINT_SIZE_FEATURE_ENTITY,
    show: false,
    enabled: false
  },
  pointOpacity: {
    ...DEFAULT_POINT_OPACITY_FEATURE_ENTITY,
    show: false,
    enabled: false
  },
  showWellCount: createEntityState(EntityType.ChartsFeature, {
    show: true,
    enabled: true,
    active: true
  }),
  bestFitToggle: createEntityState(EntityType.BestFitToggleFeature, {}),
  histogramToggle: createEntityState(EntityType.HistogramToggleFeature, {}),
  jitterPlotToggle: createEntityState(EntityType.JitterPlotToggleFeature, {}),
  quarterSlope: createEntityState(EntityType.SlopeLineFeature, {}),
  unitSlope: createEntityState(EntityType.SlopeLineFeature, {}),
  halfSlope: createEntityState(EntityType.SlopeLineFeature, {}),
  useProbitLineOfBestFitData: createEntityState(EntityType.ChartsFeature, {})
};

export const totalRateDateMidstreamFeatures = createMergeWithDefaults(
  TOTAL_RATE_DATE_MIDSTREAM_FEATURES
);
